module.exports = __webpack_public_path__ + "img/bus.19f3619e.jpg";